import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EffectiveRole, role } from 'auth-types';

interface LOGIN_STATE_TYPE {
  status: boolean;
  role: role;
  effectiveRole: EffectiveRole | null;
  first_name: string;
  last_name: string;
  email: string;
}

const INITIAL_STATE: LOGIN_STATE_TYPE = {
  status: false,
  role: '',
  effectiveRole: null,
  first_name: 'Student',
  last_name: '',
  email: '',
};

const loginSlice = createSlice({
  name: 'login',
  initialState: INITIAL_STATE,
  reducers: {
    setisLoggedIn(state: LOGIN_STATE_TYPE, action: PayloadAction<boolean>) {
      state.status = action.payload;
    },
    setRole(state: LOGIN_STATE_TYPE, action: PayloadAction<role>) {
      state.role = action.payload;
    },
    setEffectiveRole(state: LOGIN_STATE_TYPE, action: PayloadAction<EffectiveRole | null>) {
      state.effectiveRole = action.payload;
    },
    setUserFirstName(state: LOGIN_STATE_TYPE, action: PayloadAction<string>) {
      state.first_name = action.payload;
    },
    setUserLastName(state: LOGIN_STATE_TYPE, action: PayloadAction<string>) {
      state.last_name = action.payload;
    },
    setUserEmail(state: LOGIN_STATE_TYPE, action: PayloadAction<string>) {
      state.email = action.payload;
    },
  },
});

export const {
  setisLoggedIn,
  setRole,
  setEffectiveRole,
  setUserFirstName,
  setUserLastName,
  setUserEmail,
} = loginSlice.actions;

export default loginSlice.reducer;
